import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initFacebookPixel } from './utils/pixel';

const pixelId = process.env.REACT_APP_PIXEL_ID;

if (pixelId) {
  console.log("✅ Försöker initiera Facebook Pixel med ID:", pixelId);
  initFacebookPixel();
} else {
  console.warn("⚠️ Ingen REACT_APP_PIXEL_ID hittades. Pixel initieras inte.");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
